interface GetFullUrlParams {
  siteUrl: string;
  pageSegment: string;
  breadcrumbSegment?: string;
}

// i.e. does it start with a protocol string like https:// or mailto://
const absoluteUrlRegex = new RegExp('^(?:[a-z]+:)?//', 'i');

export function getHostName(url: string) {
  const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
  if (match !== null && match.length > 2 && typeof match[2] === 'string' && match[2].length > 0) {
    return match[2];
  }

  return null;
}

export function isAbsoluteUrl(url: string) {
  return absoluteUrlRegex.test(url);
}

export function isExternalUrl(url: string) {
  return absoluteUrlRegex.test(url) || url.startsWith('mailto');
}

/**
 * Constructs a full URL by combining the site URL, breadcrumb URL, and page URL.
 *
 * @param {Object} params - The parameters for constructing the full URL.
 * @param {string} params.siteUrl - The base URL of the site (e.g., "https://tastyfx.com").
 * @param {string} [params.breadcrumbSegment] - Optional breadcrumb URL segment, which will be inserted between the site URL and page URL (e.g., "help-and-support/my-accounts").
 * @param {string} params.pageSegment - The specific page URL segment (e.g., "/tax-information").
 *
 * @returns {string} Page full URL (siteUrl + breadcrumbSegment + pageSegment).
 */
export const getFullUrl = ({ siteUrl, breadcrumbSegment, pageSegment }: GetFullUrlParams): string => {
  const cleanSiteUrl = siteUrl.replace(/\/+$/, ''); // Remove trailing slashes from siteUrl
  const cleanBreadcrumbSegment = breadcrumbSegment?.replace(/^\/+|\/+$/g, ''); // Remove leading and trailing slashes from breadcrumbSegment
  const cleanPageSegment = pageSegment.replace(/^\/+|\/+$/g, ''); // Remove leading and trailing slashes from pageSegment

  return `${cleanSiteUrl}/${cleanBreadcrumbSegment ? cleanBreadcrumbSegment + '/' : ''}${cleanPageSegment}`;
};
